import React from "react";
import ContextBasedDropdownSelector from "../../../customDashboards/common/presentation/selectors/ContextBasedDropdownSelector";

export default function ModuleSelector() {
    const dashboardRegistry = window.dashboardRegistry;
    const dashboardRegistryKeys = Object.keys(dashboardRegistry);

    const organicOptions = (dashboardRegistryKeys?.map((key) => ({
            value: dashboardRegistry[key].path,
            label: dashboardRegistry[key].name,
        })) || []).sort((a, b) => a.label.localeCompare(b.label));

    const options = [
        { value: "All", label: "All" },
        ...organicOptions
    ]

    return (
        <ContextBasedDropdownSelector
            autoSelectFirstOption={false}
            options={options}
            disableClearable={false}
            label={"Dashboard Filter"}
            contextKey={"module"}
            defaultValue={"All"}
        />
    );
}

